<template>
  <div id="app" class="flex-wrap-column-center" :class="[showTimeline ? 'timeline-present' : '', { 'fixed': isFixed && this.$store.state.isMobile, 'using-IE': this.isIE, 'msie-11': this.isIE11 }]">
    <transition name="fade-long">
      <div v-if="this.preloader" id="preloader" class="d-flex justify-content-center align-items-center">
        <svg id="logo" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 73.3 99.9" style="enable-background:new 0 0 73.3 99.9;" xml:space="preserve">
          <path ref="path1" class="st0" d="M51.7,33.8c0-1.2,0-2.5-0.1-3.7c-5.7,4.8-15,4.5-15,4.5s-9.3,0.4-15-4.5c-1.3,27,15,35.8,15,35.8 S51.5,57.9,51.7,33.8"/>
          <path ref="path1o" class="st0 over" d="M51.7,33.8c0-1.2,0-2.5-0.1-3.7c-5.7,4.8-15,4.5-15,4.5s-9.3,0.4-15-4.5c-1.3,27,15,35.8,15,35.8 S51.5,57.9,51.7,33.8"/>
          <path ref="path2" class="st0" d="M28.4,66.5c14.5,11.6,34,16.4,34,16.4s-7.2,16.8-25.7,16.8c-18.2,0-25.6-16.3-25.8-16.8H11 c4-1.1,7.9-2.4,11.7-3.9c2.7,1.7,7,4.1,10.1,5.6c-2.1,0.8-4.2,2-6.5,3c3.1,2,6.7,3.1,10.4,3.1c1.4,0,6.5,0.5,10.9-3.1 C13.7,74.1,2.7,56.3,0.7,37.2l-0.1-0.8c-0.3-2.9-0.4-5.7-0.4-8.6v-1.4l7.1,5c3.2,2.1,6.9,4.4,10.1,6.3c0.3,3.1,0.9,6.2,1.7,9.2 l-5.7-3c0.4,2.1,1,4.2,1.9,6.1l0,0C18,56.6,22.8,62,28.4,66.5"/>
          <path ref="path2o" class="st0 over" d="M28.4,66.5c14.5,11.6,34,16.4,34,16.4s-7.2,16.8-25.7,16.8c-18.2,0-25.6-16.3-25.8-16.8H11 c4-1.1,7.9-2.4,11.7-3.9c2.7,1.7,7,4.1,10.1,5.6c-2.1,0.8-4.2,2-6.5,3c3.1,2,6.7,3.1,10.4,3.1c1.4,0,6.5,0.5,10.9-3.1 C13.7,74.1,2.7,56.3,0.7,37.2l-0.1-0.8c-0.3-2.9-0.4-5.7-0.4-8.6v-1.4l7.1,5c3.2,2.1,6.9,4.4,10.1,6.3c0.3,3.1,0.9,6.2,1.7,9.2 l-5.7-3c0.4,2.1,1,4.2,1.9,6.1l0,0C18,56.6,22.8,62,28.4,66.5"/>
          <path ref="path3" class="st0" d="M47.7,73c0.8,0.4,1.6,0.7,2.4,1.1c20.1-13.6,22.9-30.4,22.9-47.8c0,0-9.8,6.6-17.2,11.1 c-0.3,3.1-0.9,6.2-1.7,9.2l5.8-3c-0.8,3.1-1.5,5-1.6,5.2c-3.2,8.7-10,15.5-17.7,20.7C43,70.8,45.4,72,47.7,73"/>
          <path ref="path3o" class="st0 over" d="M47.7,73c0.8,0.4,1.6,0.7,2.4,1.1c20.1-13.6,22.9-30.4,22.9-47.8c0,0-9.8,6.6-17.2,11.1 c-0.3,3.1-0.9,6.2-1.7,9.2l5.8-3c-0.8,3.1-1.5,5-1.6,5.2c-3.2,8.7-10,15.5-17.7,20.7C43,70.8,45.4,72,47.7,73"/>
          <path ref="path4" class="st0" d="M45.2,22c0.6-0.8,1.2-1.6,1.6-2.6c1.1-3.2-2-5.6-5.3-9.4s-3.7-6.3-2.1-9.3C37,2,34,6.5,35.1,9.6 s2.5,7.2-1.8,7.5S29.6,12,29.6,12s-6.7,6.2-2.3,14.2c0.5,0.9,0.9,1.8,1.1,2.8c2.7,0.8,5.5,1.1,8.3,1.1c2.8,0,5.6-0.3,8.3-1.1 C41.3,26,43.4,24.3,45.2,22"/>
          <path ref="path4o" class="st0 over" d="M45.2,22c0.6-0.8,1.2-1.6,1.6-2.6c1.1-3.2-2-5.6-5.3-9.4s-3.7-6.3-2.1-9.3C37,2,34,6.5,35.1,9.6 s2.5,7.2-1.8,7.5S29.6,12,29.6,12s-6.7,6.2-2.3,14.2c0.5,0.9,0.9,1.8,1.1,2.8c2.7,0.8,5.5,1.1,8.3,1.1c2.8,0,5.6-0.3,8.3-1.1 C41.3,26,43.4,24.3,45.2,22"/>
        </svg>

        <h1 ref="preloaderText" class="position-absolute text-center">{{ preloaderText }}</h1>
      </div>
    </transition>

    <transition name="timeline-trans" mode="out-in" appear>
      <MobileNav v-if="this.$store.state.isMobile"></MobileNav>
      <timeline v-else-if="!this.$store.state.isMobile && showTimeline"/>
    </transition>

    <transition name="page-trans" mode="out-in" appear>
      <router-view/>
    </transition>

    <transition name="side-nav" mode="out-in" appear>
      <side-nav v-if="showSideNav && !this.$store.state.isMobile"/>
    </transition>

    <transition name="page-trans">
      <learn-more v-if="!this.$store.state.isMobile && $route.name !== 'overview'"/>
    </transition>

    <transition name="fade">
      <div v-if="overlay" class="drawer-overlay" @click="drawerOff()"></div>
    </transition>

    <transition name="fade">
      <div v-if="isLandscape" class="in-landscape d-flex justify-content-center align-items-center">
        <svg id="rotate-icon" width="70px" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 90.1 90">
          <g>
            <g>
              <g>
                <path class="st0" d="M63,9.4c-1.5,0-2.7-1.2-2.7-2.7S61.5,4,63,4h6.3C70.8,4,72,5.2,72,6.7s-1.2,2.7-2.7,2.7H63z M69.7,6.6 c0-0.2-0.2-0.4-0.4-0.4H63c-0.2,0-0.4,0.2-0.4,0.4S62.8,7,63,7h6.3C69.5,7,69.7,6.9,69.7,6.6z"/>
                <path class="st0" d="M66.1,86.5c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S68.3,86.5,66.1,86.5z M67.8,82.5c0-0.9-0.7-1.6-1.6-1.6 s-1.6,0.7-1.6,1.6s0.7,1.6,1.6,1.6C67,84.1,67.8,83.4,67.8,82.5z"/>
                <path class="st0" d="M47.7,76.3V12.1c0-0.3,0.1-0.6,0.3-0.8s0.5-0.3,0.8-0.3h20.3h14.1c0.3,0,0.6,0.1,0.8,0.3s0.3,0.5,0.3,0.8 v64.1c0,0.3-0.1,0.6-0.3,0.8s-0.5,0.3-0.8,0.3H66.1H48.9c-0.3,0-0.6-0.1-0.8-0.3C47.9,76.9,47.7,76.6,47.7,76.3z M50.1,13.3v61.8 h32.1V13.3H50.1z"/>
                <path class="st0" d="M9.4,63v6.3c0,1.5-1.2,2.7-2.7,2.7S4,70.8,4,69.3V63c0-1.5,1.2-2.7,2.7-2.7S9.4,61.5,9.4,63z M7,69.3V63 c0-0.2-0.2-0.4-0.4-0.4S6.2,62.8,6.2,63v6.3c0,0.2,0.2,0.4,0.4,0.4S7,69.5,7,69.3z"/>
                <path class="st0" d="M13.3,50.1v32.1h29V50.1H13.3L13.3,50.1z M89.4,85.8c-1,2.5-3.5,4.2-6.3,4.2H6.9C3.1,90,0,86.9,0,83.1v-34 c0-3.8,3.1-6.9,6.9-6.9h35.4V6.9c0-3.8,3.1-6.9,6.9-6.9h34c3.8,0,6.9,3.1,6.9,6.9v42.3v33.9c0,0.2,0,0.5,0,0.7s0,0.4-0.1,0.6v0.1 c0,0.2-0.1,0.5-0.2,0.7C89.6,85.4,89.5,85.6,89.4,85.8z M44,87.7c-0.8-0.9-1.4-1.9-1.6-3.1H12.1c-0.3,0-0.6-0.1-0.8-0.3 C11.1,84,11,83.7,11,83.4V63V48.9c0-0.3,0.1-0.6,0.3-0.8c0.2-0.2,0.5-0.3,0.8-0.3h30.1v-3.1H6.9c-2.5,0-4.5,2-4.5,4.5V63v20.1 c0,2.5,2,4.5,4.5,4.5L44,87.7L44,87.7z M44.6,83.1c0,2.5,2,4.5,4.5,4.5h17h17c1.4,0,2.7-0.6,3.5-1.6c0.1-0.1,0.2-0.2,0.3-0.4 s0.2-0.2,0.2-0.4c0.1-0.2,0.2-0.5,0.3-0.8c0.1-0.2,0.1-0.4,0.1-0.7c0,0,0-0.1,0-0.2v-0.1c0-0.1,0-0.2,0-0.4V49.2V6.9 c0-2.5-2-4.5-4.5-4.5H69.3H49.1c-2.5,0-4.5,2-4.5,4.5V83.1z"/>
                <path class="st0" d="M23.8,14.2c0.5-0.5,1.2-0.5,1.7,0l3.4,3.4c0.1,0.1,0.2,0.2,0.2,0.4c0.1,0.1,0.1,0.3,0.1,0.5s0,0.3-0.1,0.5 c-0.1,0.1-0.1,0.3-0.2,0.4l-3.4,3.4c-0.5,0.5-1.2,0.5-1.7,0s-0.5-1.2,0-1.7l1.4-1.4h-1.3c-1.8,0-3.4,0.7-4.5,1.9 s-1.9,2.8-1.9,4.5v2.5c0,0.6-0.5,1.2-1.2,1.2c-0.6,0-1.2-0.5-1.2-1.2V26c0-4.8,3.9-8.7,8.7-8.7h1.3l-1.4-1.4 C23.3,15.5,23.3,14.7,23.8,14.2z"/>
              </g>
            </g>
          </g>
        </svg>
      </div>
    </transition>
  </div>
</template>

<script>
import store from './store'
import Timeline from './components/Timeline'
import MobileNav from './components/MobileNav'
import SideNav from './components/side-nav/SideNav'
import LearnMore from './components/LearnMore'
import { bus } from '@/consts.js'
import { TimelineMax, Power2, Power4 } from 'gsap'
import 'DrawSVGPlugin'

export default {
  name: 'App',
  store,
  data () {
    return {
      isDevMode: process.env.NODE_ENV === 'development',
      showSideNav: false,
      sideNavExcludes: ['hero', 'start', 'assemble', 'lockedin', 'compete', 'triumph', 'triumphrewards', 'ticket', 'ticketclaim'],
      overlay: false,
      preloader: true,
      tl: new TimelineMax({paused: true}),
      isLandscape: false
    }
  },
  components: {
    Timeline,
    SideNav,
    LearnMore,
    MobileNav
  },
  computed: {
    preloaderText () {
      return this.isIE11 ? '' : window.clash2018.preloaderText
    },
    showTimeline () {
      return this.$route.name !== 'hero' && this.$route.name !== 'start'
    },
    showScrollToRoute () {
      return this.$route.name === 'hero' || this.$route.name === 'start' || this.$route.name === 'assemble'
    },
    isFixed () {
      return this.$route.name === 'hero' || this.$route.name === 'start' || this.$route.name === 'assemble'
    }
  },
  methods: {
    checkSideNavExcludes () {
      let inExcludesArray = this.sideNavExcludes.indexOf(this.$route.name) !== -1
      this.showSideNav = !inExcludesArray
    },
    drawerOff () {
      bus.$emit('mobileDrawerOpen')
    },
    checkLoad () {
      this.preloader = false
      bus.$emit('loadAnimation')
    },
    preloaderAnimation () {
      this.tl.fromTo(this.$refs.preloaderText, 0.7, {opacity: 0, y: 15}, {opacity: 1, y: 0, ease: Power2.easeInOut}, '0.5')
      this.tl.fromTo(this.$refs.path1, 2.7, {drawSVG: '0% 0%'}, {drawSVG: '0% 100%', ease: Power2.easeInOut}, '0')
      this.tl.fromTo(this.$refs.path1o, 3.3, {drawSVG: '0% 0%'}, {drawSVG: '0% 100%', ease: Power4.easeInOut}, '1.6')

      this.tl.fromTo(this.$refs.path2, 2.7, {drawSVG: '0% 0%'}, {drawSVG: '0% 100%', ease: Power2.easeInOut}, '0')
      this.tl.fromTo(this.$refs.path2o, 3.3, {drawSVG: '0% 0%'}, {drawSVG: '0% 100%', ease: Power4.easeInOut}, '1.6')

      this.tl.fromTo(this.$refs.path3, 2.7, {drawSVG: '0% 0%'}, {drawSVG: '0% 100%', ease: Power2.easeInOut}, '0')
      this.tl.fromTo(this.$refs.path3o, 3.3, {drawSVG: '0% 0%'}, {drawSVG: '0% 100%', ease: Power4.easeInOut}, '1.6')

      this.tl.fromTo(this.$refs.path4, 2.7, {drawSVG: '0% 0%'}, {drawSVG: '0% 100%', ease: Power2.easeInOut}, '0')
      this.tl.fromTo(this.$refs.path4o, 3.3, {drawSVG: '0% 0%'}, {drawSVG: '0% 100%', ease: Power4.easeInOut}, '1.6')

      this.tl.to(this.$refs.preloaderText, 0.7, {opacity: 0, y: -15, ease: Power2.easeInOut}, '2.5')

      this.tl.play()

      this.tl.eventCallback('onComplete', this.checkLoad)
    },
    checkLandscape () {
      this.$nextTick(() => {
        if (window.innerHeight < window.innerWidth && this.$store.state.isMobile && window.innerWidth > 500) {
          this.isLandscape = true
        } else {
          this.isLandscape = false
        }
      })
    },
    setIsMobile () {
      clearTimeout(this.resizeTimer)
      this.resizeTimer = setTimeout(() => {
        bus.$emit('browserResized')
        this.checkLandscape()
        let mobileMq = !window.matchMedia('(min-width: 900px)').matches
        this.$store.dispatch('setIsMobile', mobileMq)
      }, 250)
    }
  },
  created () {
    if (this.$route.name !== 'hero') {
      this.preloader = false
    }
  },
  mounted () {
    document.documentElement.classList.add('region-' + window.clash2018.region, 'language-' + window.clash2018.language)

    if (this.isDevMode) {
      document.body.classList.add('riotbar-present')
    }

    this.checkSideNavExcludes()

    this.$nextTick(() => {
      this.setIsMobile()
      window.addEventListener('resize', this.setIsMobile)
    })

    bus.$on('closeOverlay', () => {
      this.overlay = false
    })

    bus.$on('openOverlay', () => {
      this.overlay = true
    })

    if (this.$route.name === 'hero') {
      this.preloaderAnimation()
    }
  },
  updated () {
    this.checkSideNavExcludes()

    if (this.$store.state.isMobile) {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss">
  @import './styles/main.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue